@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}
<div class="position-relative">
  @if (isLoading) {
    <loader [config]="loaderConfig" />
  }
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-4 mt-2">
      <input-field type="text" [inputFormControl]="getCategoryCodeInput()" label="Code" placeholder="Code" />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field type="text" [inputFormControl]="getCategoryNameInput()" label="Name" placeholder="Name" />
    </div>
    <div class="col-sm-4 mt-2">
      <autocomplete-field [label]="'Country'" [placeholder]="'Search...'"
        [inputFormControl]="getAutocompleteCountryInput()" [readonly]="readonlyCompaniesForm" valueType="number"
        [apiService]="countriesService" [apiMethod]="'list'" [minChars]="1" [useApiSearch]="true" [nameApiSearch]="'name'"
        [optionsKey]="'countries'" [valueOption]="'name'" [keyOption]="'countryId'" [preventAutoOpen]="preventDropdownAutoOpen" (valueChange)="onCountryChange($event)"/>
    </div>
  </div>

  <div class="row g-3 mt-1">

    <div class="col-12 col-md-4">
      <label class="fw-bold d-block mb-2">Company Logo</label>

      @if (!logoPreviewUrl) {
        <label for="logoInput" class="logo-dropzone shadow-sm">
          <i class="fa fa-cloud-upload fa-2x text-muted mb-2"></i>
          <span class="d-block text-muted small fw-semibold">Click to select a file</span>
          <span class="d-block text-muted" style="font-size: 0.75rem;">PNG, JPG, SVG, WEBP &mdash; max 2 MB</span>
        </label>
      }

      @if (logoPreviewUrl) {
        <div class="logo-preview-wrapper shadow-sm">
          <img [src]="logoPreviewUrl" alt="Logo preview" class="logo-preview-img" />
          <button type="button" class="btn btn-sm btn-danger logo-remove-btn" (click)="confirmRemoveLogo()" title="Remove logo">
            <i class="fa fa-times"></i>
          </button>
        </div>
      }

      <input
        #logoInput
        id="logoInput"
        type="file"
        accept="image/png,image/jpeg,image/svg+xml,image/webp"
        class="d-none"
        (change)="onLogoSelected($event)"
      />

      @if (logoError) {
        <div class="text-danger small mt-2">
          <i class="fa fa-exclamation-circle me-1"></i>{{ logoError }}
        </div>
      }
    </div>

    <div class="col-12 col-md-8">
      @if (logoPreviewUrl) {
        <label class="fw-bold d-block mb-2">Preview on different backgrounds</label>

        <div class="d-flex gap-2 mb-3">
          <button type="button" class="preview-toggle" [class.preview-toggle--active]="logoScenario === 'transparent'" (click)="logoScenario = 'transparent'">
            <span class="preview-swatch preview-swatch--transparent"></span>
            Transparent
          </button>
          <button type="button" class="preview-toggle" [class.preview-toggle--active]="logoScenario === 'dark'" (click)="logoScenario = 'dark'">
            <span class="preview-swatch preview-swatch--dark"></span>
            Dark
          </button>
          <button type="button" class="preview-toggle" [class.preview-toggle--active]="logoScenario === 'light'" (click)="logoScenario = 'light'">
            <span class="preview-swatch preview-swatch--light"></span>
            Light
          </button>
        </div>

        <div class="logo-scenarios-preview">
          <div class="logo-scenario-bg" [ngClass]="{
            'logo-scenario-transparent': logoScenario === 'transparent',
            'logo-scenario-dark': logoScenario === 'dark',
            'logo-scenario-light': logoScenario === 'light'
          }">
            <img [src]="logoPreviewUrl" [alt]="'Logo ' + logoScenario + ' bg'" />
          </div>
          <span class="logo-scenario-label">{{ logoScenario | titlecase }}</span>
        </div>
      } @else {
        <div class="logo-scenarios-placeholder">
          <i class="fa fa-picture-o fa-2x text-muted mb-2"></i>
          <span class="d-block text-muted small">Upload a logo to see the background previews</span>
        </div>
      }
    </div>

  </div>

  <div class="text-center mt-4">
    <button type="button" class="btn btn-primary me-4 px-4 py-2" (click)="goBack()">
      Back
    </button>
    <button type="button" class="btn btn-success px-4 py-2" [disabled]="isLoading" (click)="submitForm()">
      Save
    </button>
  </div>
</form>
</div>